import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const tankMaxLitreWeightExceededSoftRule: StowageRuleBM = {
    id: StowageRuleId.TankMaxLitreWeightExceededSoftRule,
    name: 'The litre weight of the stowed cargo should not exceed the tank maximum litre weight soft rule.',
    lastUpdatedUtc: '2024-07-26T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content litre weight',
                            fieldPath: 'getTankContentLitreWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Tank litre weight soft rule',
                            fieldPath: 'tank.litreWeightSoftRule',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'This product has a high litre weight. Please check the volume that can be stored in this tank.',
    },
};
